<template>
    <div id="review">
     

    <form>
            
        <div class="title">
            <h3><span>{{user.hotel}}</span> {{lang.whatThink}}</h3>
            <RatingTotal :lang="lang" :max="5" :lists="userCheckList" :total="total"/>
        </div>

        <RatingList :lang="lang" :max="5" :lists="userCheckList" @ratings="userChecked" />

        <!-- default stayType 이지만 현재는 api 응답값으로 전달받음으로 사용x -->
        <!-- <div class="selective-list">
            <p class="label">{{lang.goal_travel}}</p>
            <Tabs :lang="lang" 
                :selected="Object.keys(guestType).length>0 && guestType.id ? guestType.id:''" 
                :lists="getGuestType"
                 @changed="guestTypeChanged" />
            
        </div> -->

        <!-- --- 추가 요청 데이터 영역 --- -->
        <!-- <div class="selective-list" v-for="(field, index) in customFields" :key="'dynamic-'+index">
            <p class="label">{{ field.customLabel }}</p>
            <ul class="word">
                <li v-for="(option, optIdx) in field.options" :key="optIdx"
                    :class="isCustomFieldSelected(field, option) ? 'active' : ''"
                    @click="selectCustomField(field, option)"
                >
                    <span>{{ option }}</span>
                </li>
            </ul>
        </div> -->
        <!-- --- 추가 요청 데이터 영역 --- -->

        <!-- {{ customItems }} -->

        <div class="selective-list" v-for="(custom, key) in reversedCustomItems" :key="key">
            <p class="label">{{ custom.display }}<span v-if="custom.isRequired" class="required">*</span></p>
            <div class="options-input">

                <Tabs v-if="custom.type === 'radio'"
                    :lang="lang"
                    :selected="custom.itemValue.length > 0 ? custom.itemValue[0].id : ''"
                    :lists="custom.options"
                    @changed="customItemChange"
                />
                
                <ul class="word" v-else-if="custom.type === 'checkbox'">
                    <li v-for="(option, idx) in custom.options" :key="idx"
                        :class="isCheckboxSelected(key, option) ? 'active' : ''"
                        @click="customCheckboxChange(key, option)"
                    >
                        <span>{{ option.label }}</span>
                    </li>
                </ul>
                <input v-else-if="custom.type === 'input'"
                    type="text"
                    v-model="customItemsObj[key].itemValue[0].value"
                    class="custom-text-input"
                />

                <!-- radio: 선택 옵션이 handWriting일 때 -->
                <input v-if="custom.type === 'radio' && custom.itemValue.length > 0"
                    type="text"
                    v-model="customItemsObj[key].itemValue[0].text"
                    v-show="custom.itemValue[0].handWriting"
                    class="custom-text-input"
                />
                <!-- checkbox: 선택된 항목 중 handWriting이 포함된 옵션이 있을 때 -->
                <template v-if="custom.type === 'checkbox'">
                    <template v-for="(sv, si) in custom.itemValue">
                        <input v-if="sv.handWriting"
                            :key="'hw-'+si"
                            type="text"
                            v-model="customItemsObj[key].itemValue[si].text"
                            class="custom-text-input"
                        />
                    </template>
                </template>
                
            </div>
        </div>

            <div class="user-inputs">
                <Textarea :lang="lang" :txt="textarea" @realtime="inputReview"/>
                <small>{{lang.review_notice}}</small>
                
            </div>
            <div class="user-img">
                <FileUpload :lang="lang" :user="user" @emitData="inputImages"/>
                
            </div>
            <div class="msg">
                <p>{{lang.mag_thank}}</p>
            </div>

          
    </form>

    <div class="footer">
        <Button :btn="buttons.submit" @btnClick="reviewSubmit" />
    </div>

        <Footer/>

      <!-- Modal -->
       
       <!-- <TextPls v-show="isPls" :btn="send.lang" :review="review.value" @plsBtn="submit" @closePls="isPls = false">
            <div class="plsIco">
                <img :src="require(`@/assets/image/ico_pls_${replaceReview(review.value).length === 0 ? 'no' : 'yes'}.svg`)">
            </div>
            <div class="plsMsg">
                <div class="plsMsgH">
                    {{$LANG.pls_MainMsg}}
                </div>
                <div>
                    {{$LANG.pls_Thank}}
                </div>
            </div>
            <Textarea :phValue="$LANG.pls_placeholder" :reviewVal="review.value" @input="inputContents"  class="plsTextArea"/>
        </TextPls> -->

        <Modal v-if="isModal" 
            :lang="lang" 
            :values="textarea"
            @realtime="inputReview"
            @close="modalClose"
            @modalInputs="newInputReview"
            />
  </div>
</template>

<script>



import Textarea from '@/components/forms/Textarea'
import Input from '@/components/forms/Input';
import Button from '@/components/forms/Button';
import FileUpload from '@/components/forms/FileUpload'

import Analytics from '@/common/analytics.js';
import { mapActions, mapGetters } from 'vuex';

import RatingList from '@/components/widget/RatingList'
import RatingTotal from '@/components/widget/RatingTotal'
import Tabs from '@/components/forms/Tabs'

import Modal from '@/components/modal/ReviewCheck'
import Footer from '@/components/layout/Footer'
 

export default {
    name: 'Review',
    props: ['user', 'lang'],
    components: {
        Textarea, Button, Input,
        RatingTotal, RatingList, Tabs,
        FileUpload,
        Modal,
        Footer

        
    },
    async created(){
        this.customItems = {...this.$store.getters['getCustomItems']};
        this.gaevent('site-review', 'enter');
        this.userCheckList.forEach(x => {   
            x.value = 0
        });
    },
    data(){
        return {
            isLoading: true,
            isModal: false,
            gaevent(category, event) {
                Analytics.gtag('event', event,{'event_category' : category,});
                // Analytics.gtag('event', event,{'event_category' : category,});	
            },

            buttons: {
                submit: {
                    label: this.lang.submit,
                    className: 'default'
                }
            },
            guestType: {},
            textarea: {
                value: '',
                placeholder: this.lang.textA_pHolder
            },
            images: [],
            total: {
                avg: (0).toPrecision(2),
                range: 0
            },
            
            customItemsObj: {}
        }
    },

    computed: {
        ...mapGetters(['getIsLoading', 'getReviewType', 'getCheckList', 'getGuestType']),
        customItems: {
            get: function(){
                return this.customItemsObj
            },
            set: function(payload){
                this.customItemsObj = {...payload};
            }
        },
        
        // StayType을 최상단으로 위치 시키기 위해 역순 정렬
        reversedCustomItems() {
            return Object.fromEntries(Object.entries(this.customItemsObj).reverse());
        },
        userCheckList: {
            get: function(){
                return this.getCheckList
            },
            set: function(payload){
                
                this.userCheckList.forEach(x => {
                    if(x.id === payload.type.id){
                        x.value = payload.value
                    }
                });
                this.checkTotal();

               
            }
        },
        getRatingTotal(){
            return this.total
        },

    },
    methods: {
        ...mapActions(['setIsLoading']),
        checkRequiredFields(){
            for (const key in this.customItems) {
                const { itemValue, type, isRequired, display } = this.customItems[key];
                if (!isRequired) continue;
                let empty = false;
                if (type === 'radio') {
                    const selected = itemValue[0];
                    empty = !selected || !(selected.handWriting && selected.text ? selected.text : selected.itemValueKey);
                } else if (type === 'checkbox') {
                    empty = itemValue.length === 0;
                } else if (type === 'input') {
                    empty = !itemValue[0] || !itemValue[0].value;
                }
                if (empty) return display || key;
            }
            return null;
        },
        buildCustomArr(){
            const customArr = {};
            for (const key in this.customItems) {
                if (key === 'stayType') continue;
                const { itemValue, display, type } = this.customItems[key];
                if (type === 'radio') {
                    if (!itemValue.length) continue;
                    const { handWriting, text, itemValueKey = '', itemValue: optVal = '' } = itemValue[0];
                    if (!optVal) continue;
                    customArr[key] = {
                        itemValue: [{ itemValue: optVal, value: handWriting && text ? text : itemValueKey }],
                        display: display || key.toUpperCase()
                    };
                } else if (type === 'checkbox') {
                    if (!itemValue.length) continue;
                    customArr[key] = {
                        itemValue: itemValue.map(v => ({
                            itemValue: v.itemValue,
                            value: v.handWriting && v.text ? v.text : v.itemValueKey
                        })),
                        display: display || key.toUpperCase()
                    };
                } else if (type === 'input') {
                    if (!itemValue[0] || !itemValue[0].value) continue;
                    customArr[key] = {
                        itemValue: [{ itemValue: '', value: itemValue[0].value }],
                        display: display || key.toUpperCase()
                    };
                }
            }
            return customArr;
        },
        customItemChange(payload){
            const { id, key } = payload;
            const current = this.customItemsObj[key].itemValue;
            this.customItemsObj[key].itemValue = current.length > 0 && current[0].id === id ? [] : [{ ...payload }];
        },
        customCheckboxChange(key, option){
            const values = this.customItemsObj[key].itemValue;
            const idx = values.findIndex(v => v.id === option.id);
            if (idx > -1) {
                values.splice(idx, 1);
            } else {
                values.push({ ...option });
            }
        },
        isCheckboxSelected(key, option){
            return this.customItemsObj[key].itemValue.some(v => v.id === option.id);
        },
        checkTotal(){
             let total = 0, count=0, avg = 0;
                this.userCheckList.forEach(x=>{
                    if(x.value>0){
                    total+=x.value;
                    ++count;
                    }
                });
                avg = (total/count).toPrecision(2);
                const value = total===0 ? 0 : Math.floor(avg)<1?1:Math.floor(avg);
                this.total ={ ... {
                    avg: total===0 ? (0).toPrecision(2):avg < 1 ? (1).toPrecision(2) : avg,
                    range: value
                }}
        },
        userChecked(payload){
            this.userCheckList = payload;
        },

        guestTypeChanged(payload){
            this.guestType = this.guestType === payload ? '':payload;
        },

        /* --- 추가 요청 데이터 영역 --- */
        selectCustomField(field, option) {
            if (field.type === 'radio') {
                field.value = field.value === option ? "" : option;
            } else if (field.type === 'checkbox') {
                const index = field.value.indexOf(option);
                if (index > -1) {
                    field.value.splice(index, 1);
                } else {
                    field.value.push(option);
                }
            }
        },

        isCustomFieldSelected(field, option) {
            if (field.type === 'radio') {
                return field.value === option;
            } else if (field.type === 'checkbox') {
                return field.value.indexOf(option) > -1;
            }
            return false;
        },
        /* --- 추가 요청 데이터 영역 --- */


        inputReview(payload){
            this.textarea.value = payload;
        },

        newInputReview(payload){

            this.textarea.value = payload.inputs;
            this.isModal = false;

            const requiredField = this.checkRequiredFields();
            if(requiredField){
                alert(`'${requiredField}' 항목은 필수입력사항입니다.`);
                return;
            }
            this.setIsLoading(true);

            const stayType = this.customItems.stayType && this.customItems.stayType.itemValue[0]?.itemValueKey
                ? Number(this.customItems.stayType.itemValue[0].itemValueKey) : 9;

            const params = {
                key: this.user.k,
                rate: Number(this.total.avg),
                stayType
            }

            const customArr = this.buildCustomArr();
            if(Object.keys(customArr).length>0){
                params.customArr = {...customArr}
            }


                    this.userCheckList.forEach(x=>{
                        params[x.id] = Number(x.value.toFixed(2))
                    });

                    if(this.images.length>0){
                        params.images = this.images;
                    }

            
                        if(this.textarea.value.length>0){
                            params.review = this.textarea.value.trim() ;
                        }

                        
                        
                        this.$store.dispatch('setReview', params).then(res=>{
                            this.setIsLoading(false);
                        }).catch(err=>{
                            this.setIsLoading(false);
                        })
                    

        },

        inputImages (payload) {
            
            this.images = payload.data;
            this.$store.dispatch('setIsLoading', false);
        },

        modalClose(){
            this.isModal = false;
        },

        reviewSubmit(){
            const customArr = this.buildCustomArr();
            
            this.setIsLoading(true);

            const count = this.userCheckList.filter(x=>{
                return x.value === 0
            }).length;
            

            const requiredField = this.checkRequiredFields();
            if(count>0){
                alert(this.lang.msg_grade_none);
                this.setIsLoading(false);
            }else if(requiredField){
                alert(`'${requiredField}' 항목은 필수입력사항입니다.`);
                this.setIsLoading(false);
            }else{
                const txtCount = this.textarea.value.replace(/ /gi, "").replace(/(?:\r\n|\r|\n)/g, '').length;
                
                
                    const stayType = this.customItems.stayType && this.customItems.stayType.itemValue[0]?.itemValueKey
                        ? Number(this.customItems.stayType.itemValue[0].itemValueKey) : 9;

                    const params = {
                        key: this.user.k,
                        rate: Number(this.total.avg),
                        stayType
                    }

                    if(Object.keys(customArr).length>0){
                        params.customArr = { ...customArr };
                    }
                    

                    this.userCheckList.forEach(x=>{
                        params[x.id] = Number(x.value.toFixed(2))
                    });

                    if(this.images.length>0){
                        params.images = this.images;
                    }

                    
                    
                    if(txtCount>4){
                        params.review = this.textarea.value.trim() ;
                        
                        this.$store.dispatch('setReview', params).then(res=>{

                            this.setIsLoading(false);
                        });
                        
                    }else{
                        this.setIsLoading(false);
                        this.isModal = true;
                    }

                   
                    


                
            }
        }
    }
}
</script>

<style lang="scss" scoped>

#review {
    

    form {
        padding: 24px;
        min-height: calc(100vh - 142px);
        .title{
            h3 {
                text-align: center;
                margin-bottom: 24px;
                span {
                    color: $color-point;
                }
            }
        }
        div {
            &.selective-list{
                margin-bottom: 24px;
            }
            
            &.user-inputs{
                small{
                    color: $color-sub-txt;
                }
                margin-bottom: 24px;
            }
            
            &.user-img{
                small{
                    color: $color-sub-txt;
                }
            }
            &.msg{
                margin: 24px 0;
                text-align: center;
                *{
                    color: $color-point;
                }
            }
            
        }
    }

    .seleted-option{
        @include flexs(center, flex-start, unset, wrap);
        input{
            margin-top: 4px;
        }
    }

    .footer {
        height: 56px;
        // position: fixed;
        // bottom: 0;
        // left: 0;
        // right: 0;

        >button {
            width: 100%;
            height: 100%;
            border-radius: 0;
            font-size: 1.2em;
        }
    }

    .label .required {
        color: $color-point;
        margin-left: 2px;
    }

    .custom-text-input {
        width: 100%;
        padding: .5em .8em;
        border: 1px solid #E1E1E1;
        border-radius: 8px;
        font-size: 0.9em;
        outline: none;
        &:focus {
            border-color: $color-point;
        }
    }

    /* --- 추가 요청 데이터 영역 --- */
    ul.word {
        li {
            display: inline-block;
            margin-right: 4px;
            margin-bottom: 4px;
            border-radius: 16px;
            padding: .4em .8em;
            background-color: #F4F4F4;
            cursor: pointer;
            span{
                color: #898989;
            }
            &.active{
                background-color: $color-point;
                span{
                    color: #FFFFFF;
                }
            }
        }
    }
    /* --- 추가 요청 데이터 영역 --- */
}

</style>